import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';

const getUserTeamIds = (teams = [], userId) => {
  if (!userId) return [];

  return teams
    .filter((team) =>
      [...(team?.members || [])]
        .map((member) => fkOrId(member))
        .includes(userId)
    )
    .map((team) => team.id);
};

export default getUserTeamIds;
